import { ROLE, type Role } from './domain.js'

/**
 * A Record, not a function with a default: adding a role to the enum then becomes a
 * typecheck failure here rather than a raw SUPER_MANAGER reaching a screen, which is
 * exactly how the sidebar came to print one.
 */
const LABELS: Record<Role, string> = {
  [ROLE.SUPER_MANAGER]: 'Super manager',
  [ROLE.MANAGER]: 'Manager',
  [ROLE.EMPLOYEE]: 'Employee',
}

export function roleLabel(role: Role): string {
  return LABELS[role]
}
